import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { TituloHeaderComponent } from './components/titulo-header/titulo-header.component';
import { ModalLoginComponent } from './components/modal-login/modal-login.component';
import { LoadingComponent } from './components/loading/loading.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { CardComponent } from './components/card/card.component';
import { SwitchComponent } from './components/switch/switch.component';
import { TablaComponent } from './components/tabla/tabla.component';
import { DataTablesModule } from 'angular-datatables';
import { TablaTemplateDirective } from './directives/template.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { PDFViewerComponent } from './components/pdfviewer/pdfviewer.component';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ModalPDFViewerComponent } from './components/modal-pdfviewer/modal-pdfviewer.component';
import { PdfviewerSimpleComponent } from './components/pdfviewer-simple/pdfviewer-simple.component';

@NgModule({
  declarations: [
    CardComponent,
    FooterComponent,
    LoadingComponent,
    ModalLoginComponent,
    NavbarComponent,
    SwitchComponent,
    TablaComponent,
    TituloHeaderComponent,
    TopbarComponent,
    TablaTemplateDirective,
    SafeUrlPipe,
    PDFViewerComponent,
    ModalPDFViewerComponent,
    PdfviewerSimpleComponent,
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    TituloHeaderComponent,
    ModalLoginComponent,
    LoadingComponent,
    TopbarComponent,
    CardComponent,
    SwitchComponent,
    TablaComponent,
    TablaTemplateDirective,
    SafeUrlPipe,
    PDFViewerComponent,
    ModalPDFViewerComponent,
    PdfviewerSimpleComponent
  ],
  imports: [CommonModule, RouterModule, DataTablesModule, PdfViewerModule],
})
export class SharedModule { }
